import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DraftService {

  constructor(private http: HttpClient) { }
  
  getRequest(url:string): Observable<any>{

    return this.http.get(url)
    .pipe(
      catchError(this.handleError)
    );
  }
  updateRequest(url:string,body:any): Observable<any>{
    console.log('url');
    console.log(url);
    console.log('body');
    console.log(body);


    return this.http.put(url,body)
    .pipe(
      catchError(this.handleError)
    );
  }
  sendContact(url:string, body:any): Observable<any>{
    return this.http.post(url,body)
    .pipe(
      catchError(this.handleError)
    );
  }  
  handleError(error: HttpErrorResponse) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      console.error(
        `Backend returned code ${error.status}, body was: `, error.error);
    }
    // Return an observable with a user-facing error message.
    return throwError(() => new Error('Something bad happened; please try again later.'));
  }
}
